import Event from '../../core/Event';

export default class EstimationProductsNextRequested extends Event {
    public static type = 'EstimationProductsNextRequested';

    constructor() {
        super(EstimationProductsNextRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/EstimationProductsNextRequested.ts